import HeroBanner from './components/HeroBanner';
import HotMovies from './components/HotMovies';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import Features from './components/Features';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '麻花影院',
    url: 'https://mahua.tv',
    description: '麻花影院提供海量高清影视内容免费在线观看，涵盖最新电影、热播电视剧、热门综艺、动漫番剧等全集资源。高清画质不卡顿，更新快，无需付费即可畅享。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mahua.tv/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '麻花影院',
    url: 'https://mahua.tv',
    description: '免费在线影视播放平台',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <HeroBanner />
        <HotMovies />
        <CategorySection />
        <LatestUpdates />
        <Features />
      </main>
    </>
  );
}